<template>
  <div class="funContainer">
    <div class="staticCard">
      <img src="@/assets/img/navigation-banner-all.png" />
    </div>

    <div class="functionBtns">
      <el-row :gutter="10">
        <el-col :span="6" v-for="(item, index) of testList" :key="index">
          <NavigationBtn :icon="item.icon" :name="item.name" :type="item.type" @click="handleClickBtn(item)" />
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import NavigationBtn from '@/components/home/AppNavigateBtn.vue'

export default {
  components: {
    NavigationBtn
  },
  data() {
    return {}
  },
  methods: {
    handleClickBtn(item) {
      this.$router.push(item.path)
    }
  },
  computed: {
    testList() {
      const testList = [
        {
          icon: 'el-icon-money',
          path: '/AppSporadic',
          name: '零星',
          type: 'blue'
        },
        {
          icon: 'el-icon-coin',
          path: '/AppEvection',
          name: '差旅费',
          type: 'orange'
        },
        {
          icon: 'el-icon-bank-card',
          path: '/AppRemittance',
          name: '汇款单',
          type: 'green'
        },
        {
          icon: 'el-icon-s-order',
          path: '/AppWorkReport',
          name: '其他',
          type: 'blue'
        },
        {
          icon: 'el-icon-s-order',
          path: '/AppReportApprove',
          name: '报告',
          type: 'orange'
        },
        {
          icon: 'el-icon-message',
          path: '/AppMailRecords',
          name: '邮寄',
          type: 'green'
        }
      ]

      if (this.$store.state?.userInfo?.name) {
        const name = this.$store.state.userInfo.name
        if (['连燕燕', '沈木全', '林源晟', '姚杨'].includes(name)) {
          testList.push({
            icon: 'el-icon-s-finance',
            path: '/AppQuotationApply',
            name: '报价',
            type: 'blue'
          })
        }
      }
      return testList
    }
  }
}
</script>
<style lang="less" scoped>
.funContainer {
  margin-top: 20px;
}
.staticCard {
  // height: 150px;
  // width: 100%;
  border-radius: 20px;
  background-color: #ebf2ff;
  display: flex;
  flex: none;
  img {
    width: 100%;
  }
}
.functionBtns {
  margin-top: 10px;
  .el-col {
    margin-top: 10px;
    display: flex;
    justify-content: center;
    flex: none;
  }
}
</style>
